/* PHOFAY back-to-top arrow: appears after scrolling down, scrolls smoothly to the top. Self-contained (injects its own CSS). */
(function () {
  if (window.__phofayTop) return;
  window.__phofayTop = true;
  var css = [
    '.phofay-top{position:fixed;right:1.6rem;bottom:calc(1.6rem + env(safe-area-inset-bottom,0px));width:46px;height:46px;padding:0;border:0;border-radius:50%;cursor:pointer;z-index:40;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#d9a58e 0%,#b76e79 100%);box-shadow:0 8px 22px rgba(169,86,114,.35),0 0 0 4px rgba(255,214,226,.45);opacity:0;visibility:hidden;transform:translateY(12px);transition:opacity .3s ease,transform .3s ease,visibility .3s,box-shadow .25s ease}',
    '.phofay-top.is-visible{opacity:1;visibility:visible;transform:none}',
    '.phofay-top:hover{box-shadow:0 12px 30px rgba(217,143,165,.55),0 0 0 6px rgba(255,214,226,.55)}',
    '.phofay-top:focus-visible{outline:2px solid #a95672;outline-offset:3px}',
    '.phofay-top svg{width:20px;height:20px}',
    'body:has(main[data-template^=product]) .phofay-top{bottom:calc(9rem + env(safe-area-inset-bottom,0px))}',
    '@media(prefers-reduced-motion:reduce){.phofay-top{transition:none}}'
  ].join('');
  function init() {
    var s = document.createElement('style');
    s.textContent = css;
    document.head.appendChild(s);
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'phofay-top';
    b.setAttribute('aria-label', 'Back to top');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg>';
    document.body.appendChild(b);
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      b.classList.toggle('is-visible', y > 600);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    b.addEventListener('click', function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    update();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
